<template>
  <naj-button to="/" size="small" square class="back-btn">
    {{ local.common.backToHome }}
  </naj-button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.back-btn {
  margin-top: 20px;
}
</style>
